// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"770f7d72","344":"dad71118","375":"98e71234"}[chunkId] + ".chunk.js";
};